module.exports = __webpack_public_path__ + "static/media/objCompleteLogo_mobile.bfefc5e1.png";